import { Injectable } from '@angular/core';
import { ProjectStore } from '@frontend-site/shared/core';
import { RouteChangeHandler, RouterState } from '@frontend-site/shared/router-store';
import { BehaviorSubject, distinctUntilChanged, Observable } from 'rxjs';
import { isProjectScope } from '../utils/is-project-scope';

@Injectable({ providedIn: 'root' })
export class ProjectDetailsCleanerService implements RouteChangeHandler {
    private readonly isInScopeSubject = new BehaviorSubject<boolean>(false);
    readonly isInScope$: Observable<boolean> = this.isInScopeSubject.asObservable().pipe(distinctUntilChanged());

    constructor(private readonly projectStore: ProjectStore) {}

    handleRouteChange(route: RouterState): void {
        const wasInScope = this.isInScopeSubject.getValue();
        const currentlyInScope = isProjectScope(route);

        this.clearProjectIfExited(currentlyInScope, wasInScope);
        this.updateInScope(currentlyInScope);
    }

    private clearProjectIfExited(currentlyInScope: boolean, wasInScope: boolean): void {
        const isExitedScope = wasInScope && !currentlyInScope;
        if (isExitedScope) {
            this.projectStore.clearSelectedProject();
        }
    }
    private updateInScope(isInScope: boolean): void {
        this.isInScopeSubject.next(isInScope);
    }
}
